module.exports = __webpack_public_path__ + "img/02-iPhone.41e63f08.png";